<template>
  <div>
    <div class="tw-bg-white tw-shadow tw-border-t tw-border-gray-200">
      <base-content class="tw-pt-3 tw-pb-3.5">
        <base-breadcrumbs :breadcrumbs="breadcrumbs" />
      </base-content>
      <base-content class="tw-pb-0 tw-pt-0">
        <div class="tw-flex tw-justify-between">
          <h1 class="tw-text-xl sm:tw-text-xl md:tw-text-2xl tw-leading-tight tw-text-gray-900 tw-mb-0 tw-font-thin">Subscription</h1>
          <base-button @click="activate"
            >Activate Subscription
            <template v-slot:icon>
              <plus-icon /> </template
          ></base-button>
        </div>
        <base-tabs class="tw-mt-2 tw-pb-4 md:tw-pb-0 tw-mb-0" no-border @click="tabClick($event)">
          <base-tab :selected="$route.meta.component === 'SubscriptionCard'" title="My Subscription" />
          <base-tab :selected="$route.meta.component === 'PaymentHistory'" title="Payment History" />
        </base-tabs>
      </base-content>
    </div>
    <base-content>
      <component ref="dynamicComponent" :is="currentComponent" :business-id="businessId" />
    </base-content>
    <activate-subscription ref="activate" :business-id="businessId" @save="reload" />
  </div>
</template>

<script>
import { PlusIcon } from "@/assets/svgs";

export default {
  name: "BusinessSubscription",
  components: {
    SubscriptionCard: () => import("@/views/business/business-subscription/components/SubscriptionCard"),
    PaymentHistory: () => import("@/views/business/business-subscription/components/PaymentHistory"),
    ActivateSubscription: () => import("@/views/business/business-subscription/components/ActivateSubscription"),
    PlusIcon,
  },
  props: {
    businessId: String,
  },
  data() {
    return {
      tabs: [{ title: "My Subscription", component: "BusinessSubscription", route: "details" }, { title: "Payment History", component: "PaymentHistory", route: "payments" }],
    };
  },
  computed: {
    currentComponent() {
      return this.$route.meta.component;
    },
    breadcrumbs() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return [{ title: "Settings", onClick: () => this.$router.push(`/businesses/${this.businessId}/business`) }, { title: "Subscription" }];
    },
  },
  methods: {
    href(path) {
      if (this.$route.path !== path) {
        this.$router.push({
          path,
          params: { businessId: this.businessId },
        });
      }
    },
    tabClick(tabTitle) {
      const tab = this.tabs.find((t) => t.title === tabTitle);
      this.href(`/businesses/${this.businessId}/business/subscription/${tab.route}`);
    },
    activate() {
      this.$refs.activate.show();
    },
    reload() {
      if (this.currentComponent === "BusinessSubscription") {
        this.$refs.dynamicComponent.getMySubscriptions();
      } else if (this.currentComponent === "PaymentHistory") {
        this.$refs.dynamicComponent.loadPage();
      }
    },
  },
};
</script>
